import { itemsObject } from '@builder/common/utilities';

/**
 * Returns all the triggers in the recipe 
 * 
 * @returns {Array} with triggers
 */
const getTriggers = () => {
    return itemsObject( 'get', {
        filter: { itemType: 'trigger' },
        format: 'array',
    });
}

export default getTriggers;
